var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDexGuru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F14",
    d: "M19.854 40c10.965 0 19.854-8.954 19.854-20S30.818 0 19.854 0C8.889 0 0 8.954 0 20s8.889 20 19.854 20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    d: "M19.866 6.901c-1.43 0-2.547.566-3.286 1.485-.716.89-1.016 2.031-1.016 3.12 0 1.152.45 2.446 1.146 3.457.682.99 1.77 1.938 3.156 1.938 1.384 0 2.472-.944 3.155-1.933.697-1.01 1.147-2.305 1.147-3.462 0-1.086-.286-2.23-1-3.122-.739-.925-1.86-1.483-3.302-1.483Zm-2.34 4.605c0-.75.208-1.418.577-1.877.346-.43.89-.752 1.763-.752.898 0 1.438.324 1.775.745.361.453.566 1.119.566 1.884 0 .695-.292 1.604-.796 2.335-.518.75-1.09 1.085-1.545 1.085-.453 0-1.025-.335-1.544-1.09-.506-.733-.797-1.642-.797-2.33Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M13.324 21.364c-1.988-.222-3.63 1.38-3.63 3.019 0 1.63 1.276 3.11 3.677 3.11.863 0 1.745-.38 2.713-1.09 1.128-.828 2.064-1.8 3-2.775.94-.976 1.88-1.954 3.018-2.788 1.127-.826 2.414-1.47 3.867-1.47 3.311 0 5.638 2.2 5.638 5.087 0 2.879-2.72 5.326-5.807 4.982-1.239-.138-2.692-.56-3.86-1.707l1.368-1.415c.743.73 1.716 1.048 2.707 1.158h.001c1.988.223 3.63-1.379 3.63-3.018 0-1.631-1.277-3.111-3.677-3.111-.863 0-1.745.38-2.713 1.091-1.128.828-2.064 1.8-3.001 2.774-.94.977-1.88 1.954-3.017 2.788-1.127.827-2.414 1.47-3.867 1.47-3.311 0-5.638-2.199-5.638-5.086 0-2.88 2.72-5.327 5.807-4.982 1.239.137 2.692.56 3.86 1.706l-1.368 1.415c-.743-.73-1.716-1.048-2.707-1.157h-.001Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 6.683,
    x2: 22.728,
    y1: 16.389,
    y2: 32.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6046FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46D7AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 6.683,
    x2: 22.728,
    y1: 16.389,
    y2: 32.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6046FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46D7AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDexGuru);
export default __webpack_public_path__ + "static/media/dexGuru.181132bd1e711c930d55acb2135fc887.svg";
export { ForwardRef as ReactComponent };